module.exports = __webpack_public_path__ + "static/media/kafka.e3089d8a.svg";